import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/** 获取订单列表
 * @param {Object} data
 */
export function getOrderList(data) {
  return request("".concat(BASE_URL) + "/order/list", METHOD.POST, data);
}

/** 批量修改订单状态
 * @param {Object} data
 */
export function updateOrderStatus(data) {
  return request("".concat(BASE_URL) + "/order/status", METHOD.PUT, data);
}

/** 订单导出
 * @param {Object} data
 */
export function exportOrder(data) {
  return request("".concat(BASE_URL) + "/order/export", "", data, {
    responseType: 'blob'
  });
  // window.open(`${BASE_URL}` + "/order/export?orderIds="+data);
}

/** 批量修改发货日
 * @param {Object} data
 */
export function updateOrderSendDate(data) {
  return request("".concat(BASE_URL) + "/order/scheduleSendDate", METHOD.PUT, data);
}

/** 客服备注
 * @param {Object} data
 */
export function addOrderNote(data) {
  return request("".concat(BASE_URL) + "/order/noteOfService", METHOD.POST, data);
}

/** 取消订单
 * @param {Object} data
 */
export function CancelOrder(data) {
  return request("".concat(BASE_URL) + "/order/cancel?" + data, METHOD.PUT);
}

/** 获取订单中的担当者下拉选项
 * @param {Object} data
 */
export function getSellerOptions(data) {
  return request("".concat(BASE_URL) + "/order/sellerOptions", METHOD.GET, data);
}

// 刷新物流
export function flushExpress(data) {
  return request("".concat(BASE_URL) + "/erporder/flushExpress?orderIds=" + data, METHOD.PUT);
}

// 获取传票列表
export function getYuseiOrderNoList(data) {
  return request("".concat(BASE_URL) + "/erporder/list", METHOD.POST, data);
}
//同步传票
export function syncErpOrders() {
  return request("".concat(BASE_URL) + "/erporder/syncErpOrders", METHOD.GET);
}

/**
 * 同步ERP端网络订单的处理结果
 *   GET /erpTimerApi/syncOrderStatus
 *   接口ID：244501533
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-244501533
 * @return {Promise<AxiosResponse<T>>}
 */
export function syncOrders() {
  return request("".concat(BASE_URL) + "/erpTimerApi/syncOrderStatus", METHOD.GET);
}

/**
 * 显示纳品书下载链接
 * @param id 传票id
 * @returns {Promise<AxiosResponse<T>>}
 */
export function showPdfDownloadUrl(id) {
  return request("".concat(BASE_URL) + "/erporder/showPdfDownloadUrl/".concat(id), METHOD.PUT);
}